import { isSafari, isMobile } from 'react-device-detect';

let d3;
let Hammer;
let svgPanZoom;
let utils;
let initSelect;
let mousedown;

let svg;
let splPanZoom;

export let canvas;

export const drawSeatingPlan = (node, data, width, height, actions) => {
  d3 = require('d3')
  Hammer = require('hammerjs')
  svgPanZoom = require('svg-pan-zoom')
  initSelect = require('./select').initSelect
  mousedown = require('./select').mousedown
  utils = require('./utils')

  const panZoomOpts = {
    zoomEnabled: true,
    panEnabled: true,
    dblClickZoomEnabled: false,
    fit: !isMobile,
    zoomScaleSensitivity: 1,
    minZoom: isMobile ? 1.4 : 0.75,
    maxZoom: isMobile ? 3 : 2,
    center: true,
    customEventsHandler: {
      haltEventListeners: ['touchstart', 'touchend', 'touchmove', 'touchleave', 'touchcancel'],
      init: initCustomEventsHandler,
      destroy: destroyCustomEventsHandler,
    },
    onPan: function () { svg.node().style.cursor = 'move'; },
  };

  if (svg) {
    svg.selectAll('*').remove()
  }
  svg = d3.select(node);
  svg
    .classed('waiting-for-content', true)
    .classed('pub', true);

  utils.init(svg, dummySvgFromData(data), actions);

  const viewBoxStr = utils.isIE()
    ? `0 0 ${width}mm ${height}mm`
    : `0 0 ${width} ${height}`

  svg
    .attr('viewBox', viewBoxStr)

  if (width > 10000 || height > 10000) panZoomOpts.maxZoom = 4
  if (width > 30000 || height > 30000) panZoomOpts.maxZoom = 6
  if (width > 70000 || height > 70000) panZoomOpts.maxZoom = 10
  
  canvas = svg
    .append('g')
    .attr('class', 'canvas')
  drawData(data)
  setTimeout( () => {
    window.splPanZoom = splPanZoom = svgPanZoom(node, panZoomOpts)
    // try {
    //   if (isMobile) splPanZoom.zoom(2)
    // } catch(e) { console.error('matrix cannot zoom') }
  }, 1000)
  svg
    .on('mouseup', resetCursor)
    .on('mousedown', resetCursor);
  let svgHeight = 'calc(100vh - 170px)';
  d3.select('.spl-container').style('height', svgHeight);
  setupZoomBtns();
  fixSafariRot();
}

function fixSafariRot() {
  if (isMobile) {
    d3.selectAll('.spl-rot-35-l text').attr('dy', '0.4em').attr('dx', '0')
    d3.selectAll('.spl-rot-35-r text').attr('dy', '0.4em').attr('dx', '-0')
    return
  }
  if (isSafari) {
    d3.selectAll('.spl-rot-35-l text').attr('dy', '-0.4em').attr('dx', '0.4em')
    d3.selectAll('.spl-rot-35-r text').attr('dy', '0.7em').attr('dx', '-0.7em')
    return
  }
}

function dummySvgFromData(data) {
  const dummySvg = document.createElement('svg');
  dummySvg.insertAdjacentHTML('beforeend', data);
  return dummySvg;
}

function drawData(data) {
  svg.select('.canvas')
    .selectAll('*').remove();
  svg.select('.canvas')
    .node()
    .insertAdjacentHTML('beforeend', data);
}

let curZoom = 1;
function setupZoomBtns() {
  d3.select('.zoom-in').on('click', function () { splPanZoom && splPanZoom.zoom(curZoom < 12 ? curZoom += 3 : 12) });
  d3.select('.zoom-out').on('click', function () { splPanZoom && splPanZoom.zoom(curZoom > -1 ? curZoom -= 3 : -1) });
  d3.select('.zoom-reset').on('click', function () {
    splPanZoom.resetZoom().fit().center();
    curZoom = 1;
  })
}

function setupAdminEvents() {
  initSelect(svg);
  utils.init(svg, null, actions);
  svg
    .on('mousedown', function () {
      if (d3.event.which === 2 ||
        (d3.event.which === 1 && d3.event.shiftKey)) {
        splPanZoom.enablePan();
        d3.event.preventDefault();
        return;
      }
      const lastClickCoords = d3.mouse(this);
      mousedown(lastClickCoords);
    })
    .on('mouseup', function () {
      d3.event.stopPropagation();
      splPanZoom.disablePan();
      resetCursor();
      if (window.editingOrderSeats) return;
      if (d3.event.ctrlKey) return;
      d3.selectAll('.selected.seat-container')
        .each(function () {
          actions.toggleCandidate(d3.select(this).attr('id'));
        });
    });
  d3.selectAll('.seat-container')
    .on('click', seatClickedByAdmin)
  d3.selectAll('.stack-sgr')
    .on('click', stackSeatClickedByAdmin)
  // .on('touchstart', seatClickedByAdmin); // TODO: Remove, this shouldn't be needed anyways
}

function stackSeatClickedByAdmin() {
  let sgr = d3.select(this);
  const firstBookedSgrSeat = sgr.select('.seat-container.booked');
  if (firstBookedSgrSeat.size() > 0) {
    firstBookedSgrSeat.classed('selected', true);
    sgr.classed('selected', true);
    utils.setCurSeats();
    utils.actions.fetchOrderBySeatClientUid(firstBookedSgrSeat.attr('id'), goToOrder);
    return;
  }
  let node = sgr.select('.seat-container:not(.candidate)');
  node = node.node() ? node : sgr.select('.seat-container.candidate');
  actions.toggleCandidate(node.attr('id'));
}

function seatClickedByAdmin() {
  let node = d3.select(this);
  if (window.location.pathname.indexOf('/ord_') > 0 && !window.editingOrderSeats) return;

  if (window.editingOrderSeats) {
    if ((!checkSeatIsBookable(node) || window.editingOrderRefund)
      && window.seats_client_uids
      && !window.seats_client_uids.includes(node.attr('id'))) return;

    node.classed('selected', !node.classed('selected'));
    utils.setCurSeats();
    return;
  }
  if (node.classed('booked')) { // a booked seat was clicked. show editOrder details
    node.classed('selected', true);
    utils.setCurSeats();
    utils.actions.fetchOrderBySeatClientUid(node.attr('id'), goToOrder);
    return;
  }
  actions.toggleCandidate(node.attr('id'));
}

function checkSeatIsBookable(node) {
  return node.attr('class').indexOf('pct_') >= 0 &&
    !node.classed('booked') &&
    !node.classed('locked');
}

function resetCursor() {
  svg.node().style.cursor = 'default';
}

function initCustomEventsHandler(options) {
  var instance = options.instance
    , initialScale = 1
    , pannedX = 0
    , pannedY = 0

  // Init Hammer
  // Listen only for pointer and touch events
  this.hammer = Hammer(options.svgElement, {
    inputClass: Hammer.SUPPORT_POINTER_EVENTS ? Hammer.PointerEventInput : Hammer.TouchInput
  })

  // Enable pinch
  this.hammer.get('pinch').set({ enable: true })

  // Handle double tap
  this.hammer.on('doubletap', function (ev) {
    instance.zoomIn()
  })

  // Handle pan
  this.hammer.on('panstart panmove', function (ev) {
    // On pan start reset panned variables
    if (ev.type === 'panstart') {
      pannedX = 0
      pannedY = 0
    }

    // Pan only the difference
    instance.panBy({ x: ev.deltaX - pannedX, y: ev.deltaY - pannedY })
    pannedX = ev.deltaX
    pannedY = ev.deltaY
  })

  // Handle pinch
  this.hammer.on('pinchstart pinchmove', function (ev) {
    // On pinch start remember initial zoom
    if (ev.type === 'pinchstart') {
      initialScale = instance.getZoom()
      instance.zoomAtPoint(initialScale * ev.scale, { x: ev.center.x, y: ev.center.y })
    }

    instance.zoomAtPoint(initialScale * ev.scale, { x: ev.center.x, y: ev.center.y })
  })

  // Prevent moving the page on some devices when panning over SVG
  options.svgElement.addEventListener('touchmove', function (e) { e.preventDefault(); });
};

function destroyCustomEventsHandler() {
  this.hammer.destroy();
}
